// styles
import {PaymentRequestButtonElement} from "@stripe/react-stripe-js";

interface ButtonProps {
  appleGooglePayPaymentRequest: any;
}

const QuickPayButton: React.FC<ButtonProps> = ({
  appleGooglePayPaymentRequest
}) => {

  return (
      <PaymentRequestButtonElement options={{paymentRequest: appleGooglePayPaymentRequest}}/>
  )
};

export default QuickPayButton;
